module.exports = __webpack_public_path__ + "static/img/to_ico_logo.e8d3d11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/to_ico_logo.png
// module id = LI3+
// module chunks = 2